import { FC } from 'react'
import ActivateNotificationIntegration, {
  RequiredActivateNotificationIntegration,
} from '@/components/modals/ActivateNotificationIntegration'

interface ActivateMaxNotificationBotProps {
  open?: boolean
  setOpen?: (open: boolean) => void
  necessarily?: boolean
  integrationId?: number | null
}

const ActivateMaxNotificationBot: FC<ActivateMaxNotificationBotProps> = (props) => (
  <ActivateNotificationIntegration provider="max" {...props} />
)

export const RequiredActivateMaxNotificationBot: FC = () => (
  <RequiredActivateNotificationIntegration provider="max" />
)

export default ActivateMaxNotificationBot
